import styled from "styled-components";

const AppContainer = styled.div`
  /* min-height: 100vh; */
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding-bottom: 4.5rem;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
`;

export default AppContainer;
